// utils/format.js
export const nfmt = (v) => {
  try { return Math.round(v).toLocaleString("fr-FR"); }
  catch { return String(v); }
};
export const nfmt2 = (v) => v == null
  ? "—"
  : Number(v).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
